import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

const FIELDS = [
  ["total_words", "Total words for the story", "e.g. 80000"],
  ["chapter_words", "Target chapter length (words)", "e.g. 3000"],
  ["chapter_minutes", "Target reading time per chapter (minutes)", "e.g. 12"],
  ["daily_words", "Words per day", "e.g. 500"],
  ["wpm", "Reader speed (words per minute)", "238"],
];

export const GoalsPanel = ({ sid, goals, onSaved }) => {
  const [v, setV] = useState(Object.fromEntries(FIELDS.map(([k]) => [k, goals[k] ?? ""])));
  const save = async () => {
    const body = Object.fromEntries(FIELDS.map(([k]) => [k, v[k] === "" ? (k === "wpm" ? 238 : null) : Math.round(Number(v[k]))]));
    try { await api.patch(`/stories/${sid}`, { goals: body }); toast.success("Goals saved"); onSaved(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="rounded-md border border-[#2D3442] bg-[#0F131A] p-5" data-testid="goals-panel">
      <div className="lf-label">Goals</div>
      <div className="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-2">
        {FIELDS.map(([k, l, ph]) => (
          <label key={k} className="text-xs text-[#A8A090]">{l}
            <Input type="number" min={0} step={1} value={v[k]} placeholder={ph} onChange={(e) => setV({ ...v, [k]: e.target.value })} className="mt-1 h-9" data-testid={`goal-${k}`} />
          </label>
        ))}
      </div>
      <p className="mt-3 text-[11px] text-[#A8A090]">Leave a goal blank to switch it off. 238 words per minute is the adult average.</p>
      <Button size="sm" className="mt-4" onClick={save} data-testid="goals-save">Save goals</Button>
    </section>
  );
};
